export const collectShirtSize = (name, type, data, memberNumber) => {
  if (type === "TEAM_LEADER") {
    return {
      type: name === "SHIRT_SIZE" && "TEAM_LEADER_SHIRT_SIZE",
      payload: data
    }
  } else {
    return {
      type: name === "SHIRT_SIZE" && `TEAM_MEMBER_${memberNumber}_SHIRT_SIZE`,
      payload: data,
      index: memberNumber
    }
  }
}
